import Model, { attr, belongsTo } from '@ember-data/model';
import type Flow from 'garaje/models/flow';
import type GlobalFlow from 'garaje/models/global-flow';
import type Questionnaire from 'garaje/models/questionnaire';

export default class FlowQuestionnaire extends Model {
  @belongsTo('abstract/abstract-flow', { async: false, inverse: 'flowQuestionnaires', polymorphic: true })
  declare flow: Flow | GlobalFlow;

  @belongsTo('questionnaire', { async: false, inverse: 'flowQuestionnaires' })
  declare questionnaire: Questionnaire;

  @attr('number') declare position: number;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'flow-questionnaire': FlowQuestionnaire;
  }
}
